module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-flat-button",
    class: _vm.buttonClass,
    style: (_vm.buttonStyle),
    attrs: {
      "disabled": _vm.disabled,
      "keyboardFocused": _vm.keyboardFocused,
      "wrapperClass": "mu-flat-button-wrapper",
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "rippleColor": _vm.rippleColor,
      "rippleOpacity": _vm.rippleOpacity,
      "centerRipple": false
    },
    on: {
      "click": _vm.handleClick,
      "keyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [(_vm.label && _vm.labelPosition === 'before') ? _c('span', {
    staticClass: "mu-flat-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('icon', {
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.label && _vm.labelPosition === 'after') ? _c('span', {
    staticClass: "mu-flat-button-label",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd91093","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/flatButton/flatButton.vue
// module id = 3800
// module chunks = 1